import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicSizeIcon from "../DynamicSizeIcon";
import DynamicFontSize from "../DynamicFontSize";
import FormatterNumber from "../FormatterNumber";
import { useGlobalData } from "@/contexts/GlobalData";
import { cn } from "@/lib/utils";
import SubPaymentFeeInfo from "../SubPaymentFeeInfo";
interface WalletOptionPropsType extends GeneralPropsType {
  icon?: string;
  name?: string;
  balance?: number;
  isSelected?: boolean;
  showBalance?: boolean;
  unit?: string;
  onClick?: (data?: any) => any;
  layout?: "mini" | "full";
  displayText?: string;
}
function WalletOption({
  icon,
  name,
  balance,
  isSelected,
  showBalance,
  children,
  className,
  unit,
  onClick,
  layout = "mini",
  displayText
}: WalletOptionPropsType) {
  const prefix = "wallet_option_";
  const {
    translate
  } = useGlobalData();
  return <div onClick={onClick} className={clsx("border rounded-2xl flex items-center gap-2 px-3 overflow-hidden duration-300 select-none", styles.container, className, {
    "border-secondary bg-secondary/[0.16] relative after:content-[''] after:z-50 after:absolute after:rotate-[45deg] after:translate-x-[16px] after:-translate-y-[8px] after:block after:w-9 after:aspect-[2] after:bg-secondary after:right-0 after:top-0": isSelected,
    "bg-white/[0.16] border-description": !isSelected,
    "py-1.5": layout == "mini",
    "py-3": layout == "full"
  })} data-sentry-component="WalletOption" data-sentry-source-file="index.tsx">
            <DynamicSizeIcon width={24} icon={icon} className="" data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx" />
            <div className={clsx("flex gap-0.5 flex-1", {
      "flex-col items-start": layout == "mini",
      "justify-between items-center": layout == "full"
    })}>
                <div className="flex flex-col gap-1">
                    <DynamicFontSize fontSize={14} className="text-white leading-[160%] font-medium" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                        {name}
                    </DynamicFontSize>
                    {layout == "full" && <DynamicFontSize fontSize={11} className={cn("py-0.5 px-2 rounded-md bonus_bg")}>
                            <span className={"bonus_text"}>{translate(prefix + "no fee")}</span>
                        </DynamicFontSize>}
                </div>
                <DynamicFontSize fontSize={14} className="text-description leading-[140%] font-medium" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    {showBalance && !displayText && <FormatterNumber value={balance} unit={` ${unit}`} />}
                    {!showBalance && !displayText && <span>{translate(prefix + "hidden")}</span>}
                    {displayText && <SubPaymentFeeInfo />}
                </DynamicFontSize>
            </div>
        </div>;
}
export default WalletOption;